(() => {
  const initialize = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const slides = [...root.querySelectorAll('[data-runway-slide]')];
    const bars = [...root.querySelectorAll('.rw-runway-progress i')];
    const count = root.querySelector('[data-runway-count]');
    const toggle = root.querySelector('[data-runway-toggle]');
    const icon = root.querySelector('[data-runway-icon]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let index = 0, paused = motion.matches, visible = false, hovered = false, focused = false, timer;
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-current', i === index);
        slide.classList.toggle('is-previous', i === (index + slides.length - 1) % slides.length);
        slide.classList.toggle('is-next', i === (index + 1) % slides.length);
        slide.setAttribute('aria-hidden', String(i !== index));
        slide.tabIndex = i === index ? 0 : -1;
      });
      bars.forEach((bar, i) => bar.classList.toggle('is-current', i === index));
      count.textContent = String(index + 1).padStart(2, '0');
    };
    const schedule = () => {
      clearInterval(timer);
      toggle.setAttribute('aria-label', paused ? toggle.dataset.play : toggle.dataset.pause);
      icon.textContent = paused ? '▶' : 'Ⅱ';
      if (!paused && visible && !hovered && !focused && !document.hidden) timer = setInterval(() => show(index + 1), 1000);
    };
    root.querySelector('[data-runway-previous]').addEventListener('click', () => { paused = true; show(index - 1); schedule(); });
    root.querySelector('[data-runway-next]').addEventListener('click', () => { paused = true; show(index + 1); schedule(); });
    toggle.addEventListener('click', () => { paused = !paused; schedule(); });
    root.addEventListener('mouseenter', () => { hovered = true; schedule(); });
    root.addEventListener('mouseleave', () => { hovered = false; schedule(); });
    root.addEventListener('focusin', () => { focused = true; schedule(); });
    root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) { focused = false; schedule(); } });
    document.addEventListener('visibilitychange', schedule);
    motion.addEventListener('change', event => { paused = event.matches; schedule(); });
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, {threshold: .15}).observe(root);
    root.classList.add('is-ready');
    schedule();
  };
  document.querySelectorAll('[data-runway]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-runway]').forEach(initialize));
})();
